module.exports = __webpack_public_path__ + "img/sym5.0b740d46.png";